import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65644dcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-4 max-w-screen-lgm x-auto border" }
const _hoisted_2 = { class: "bg-gray-100 p-4 text-xl text-gray-700 font-semibold relative gap-2 flex flex-col justify-between items-center md:flex-row" }
const _hoisted_3 = { class: "text-center min-h-[28px]" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex flex-col gap-8 p-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-2xl font-bold text-center pb-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col gap-y-4"
}
const _hoisted_9 = { class: "flex flex-col md:flex-row gap-4 justify-between md:items-center" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "flex gap-4 flex-col justify-center items-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check !text-6xl rounded-full border p-6 text-green-500" }, null, -1))
const _hoisted_13 = { class: "text-gray-700 font-semibold" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "-mx-4" }, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-center items-center p-4"
}
const _hoisted_18 = { class: "text-xl" }
const _hoisted_19 = {
  key: 1,
  class: "availabilities gap-2"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "flex justify-center items-center p-4"
}
const _hoisted_22 = { class: "text-xl" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "block required" }
const _hoisted_25 = { class: "block required" }
const _hoisted_26 = { class: "block required" }
const _hoisted_27 = { class: "block required" }
const _hoisted_28 = { class: "block required" }
const _hoisted_29 = { class: "block" }
const _hoisted_30 = { class: "text-right text-gray-500" }
const _hoisted_31 = { class: "bg-gray-100 p-4 text-gray-700 text-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "underline font-semibold",
  href: "https://bookonline.ma",
  target: "_blank"
}, "Bookonline", -1))

import { cloneDeep, debounce } from "lodash";
import { queryParamTOArray } from "@/assets/utils";
import CPhoneInput from "@/components/phoneInput.vue";
import FormErrors from "@/components/FormErrors.vue";
import CButton from "@/components/Button.vue";
import LanguageSwitcher from "@/components/shared/languageSwitcher.vue";
import PInput from "primevue/inputtext";
import PProgressSpinner from "primevue/progressspinner";
import PInputNumber from "primevue/inputnumber";
import { compareAsc, parseISO } from "date-fns";
import PCalendar from "primevue/calendar";
import PDropdown from "primevue/dropdown";
import { genderList } from "@/assets/utils/translatedEnums";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { DateTimeToISOString, DateToISOString } from "@/assets/utils/date";
import useVuelidate from "@vuelidate/core";
import BookingOptions from "@/components/shared/BookingOptions.vue";
import PTextArea from "primevue/textarea";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useNotify } from "@/composables/useNotify";

export default /*#__PURE__*/_defineComponent({
  __name: 'Book',
  setup(__props) {

const isLoading = ref(true);
const allDays = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];
const toast = useToast();
const { t } = useI18n();
const { errorToast } = useNotify({ t });
const showError = () => {
  errorToast({
    title: t("reservation"),
    error: "ONLINE_BOOKING_ERROR",
  });
};
const book = async () => {
  try {
    if (await v$.value.$validate()) {
      const [hours, minutes] = booking.value.at.split(":");
      const reservation = cloneDeep(booking.value);
      const at = cloneDeep(day.value);
      at.setHours(Number(hours), Number(minutes));
      reservation.at = DateToISOString(at);
      await store.dispatch("online/BOOK", cloneDeep(reservation));
      goToReacapStep();
    }
  } catch {
    showError();
  }
};
const onServiceChange = () => {
  const date = day.value ?? new Date();
  monthChange({ month: date.getMonth() + 1, year: date.getFullYear() });
};
const booking = ref<any>({
  serviceId: null,
  tenantId: null,
  posId: null,
  attendeesCount: 2,
  at: null,
  client: {
    gender: null,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  },
  comment: "",
});
const isDateAvailable = ({
  day,
  year,
  month,
}: {
  day: number;
  year: number;
  month: number;
}) => {
  const date = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  const dateParsed = parseISO(date);

  return compareAsc(dateParsed, now) >= 0 && dates.value.has(date);
};
const isLoadingAvailabilities = ref(false);
const store = useStore();
const step = ref(0);

const goToAvailabilitiesStep = () => {
  step.value = 0;
};
const goToInfoStep = () => {
  step.value = 1;
};
const goToReacapStep = () => {
  step.value = 2;
};
const rules = store.getters["client/rulesToCreateAOnlineClient"];
const v$ = useVuelidate(rules, booking.value.client, { $lazy: true });
const route = useRoute();
const pos = ref<any>();

onMounted(async () => {
  const q = route.query;
  try {
    pos.value = await store.dispatch("online/RETRIEVE_POS", {
      posId: q.p as string,
      serviceIds: queryParamTOArray(q.ser as string),
    });
    booking.value.posId = q.p;
    booking.value.serviceId = queryParamTOArray(q.ser as string)?.[0];
    booking.value.tenantId = pos.value.tenantId;
    isLoading.value = false;
    const date = new Date();
    await monthChange({ month: date.getMonth() + 1, year: date.getFullYear() });
  } catch {
    showError();
  }
});
const monthChange = async ({
  month,
  year,
}: {
  month: number;
  year: number;
}) => {
  try {
    if (!dates.value) {
      dates.value = new Map();
    }

    isLoadingAvailabilities.value = true;
    const result = await store.dispatch("online/RETRIEVE_AVAILABILITIES", {
      posId: booking.value.posId,
      serviceId: booking.value.serviceId,
      month,
      year,
    });
    dates.value = result;
    isLoadingAvailabilities.value = false;
  } catch {
    showError();
  }
};

const debounceMonthChange = debounce(monthChange, 500);
const day = ref(new Date());
const dates = ref(new Map());

const chooseAt = (at: string) => {
  booking.value.at = at;
  goToInfoStep();
};
const checkAvilabilityIsNotInThePast = (availabityStr: string) => {
  const availabity = new Date(availabityStr);
  const now = new Date();

  return compareAsc(availabity, now) >= 0;
};

return (_ctx: any,_cache: any) => {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(pos.value?.name), 1),
        (pos.value?.space?.name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " - " + _toDisplayString(pos.value?.space?.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(LanguageSwitcher)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: pos.value?.logo,
          class: "block mx-auto w-20 h-20"
        }, null, 8, _hoisted_6),
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("newBooking")), 1),
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (step.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(PDropdown), {
                      class: "w-full",
                      placeholder: _ctx.$t('service'),
                      options: pos.value?.services ?? [],
                      "option-label": "name",
                      "option-value": "id",
                      "data-key": "id",
                      modelValue: booking.value.serviceId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((booking.value.serviceId) = $event)),
                      onChange: onServiceChange
                    }, null, 8, ["placeholder", "options", "modelValue"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(PInputNumber), {
                        showButtons: "",
                        step: 1,
                        min: 1,
                        modelValue: booking.value.attendeesCount,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((booking.value.attendeesCount) = $event)),
                        incrementButtonIcon: "pi pi-plus",
                        decrementButtonIcon: "pi pi-minus",
                        suffix: ` ${_ctx.$t('person', { count: booking.value.attendeesCount })}`
                      }, null, 8, ["modelValue", "suffix"]),
                      _createVNode(_unref(PCalendar), {
                        "show-icon": "",
                        "manual-input": false,
                        "min-date": new Date(),
                        placeholder: _ctx.$t('date'),
                        modelValue: day.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((day).value = $event)),
                        "date-format": "D. dd M. yy",
                        class: "flex-grow",
                        "hour-format": "24",
                        onMonthChange: _unref(debounceMonthChange)
                      }, {
                        header: _withCtx(() => [
                          (isLoadingAvailabilities.value)
                            ? (_openBlock(), _createBlock(_unref(PProgressSpinner), {
                                key: 0,
                                class: "!w-[30px] !h-[30px]"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        date: _withCtx(({ date }) => [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                      !isDateAvailable({
                        day: date.day,
                        month: date.month + 1,
                        year: date.year,
                      })
                        ? 'p-disabled pointer-events-none'
                        : 'border border-black rounded-full w-full h-full flex justify-center items-center ',
                    ])
                          }, _toDisplayString(date.day), 3)
                        ]),
                        _: 1
                      }, 8, ["min-date", "placeholder", "modelValue", "onMonthChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (step.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(BookingOptions, {
                      "show-edit": "",
                      onChangeOptions: _cache[3] || (_cache[3] = ($event: any) => (goToAvailabilitiesStep())),
                      booking: booking.value,
                      day: day.value
                    }, null, 8, ["booking", "day"])
                  ]))
                : _createCommentVNode("", true),
              (step.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(BookingOptions, {
                      booking: booking.value,
                      day: day.value
                    }, null, 8, ["booking", "day"]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("bookingGettingTreated", {
                  firstName: booking.value.client?.firstName,
                })), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _hoisted_14,
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (step.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (!booking.value.serviceId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, "(" + _toDisplayString(_ctx.$t("pleaseChooseAService")) + ")", 1)
                      ]))
                    : (
              (dates.value.get(_unref(DateTimeToISOString)(day.value) ?? {})?.availabilities ?? [])
                .length
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value.get(
                _unref(DateTimeToISOString)(day.value) ?? {}
              )?.availabilities ?? [], (availability, availabilityIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass([{
                'pointer-events-none opacity-50':
                  booking.value.attendeesCount > availability.maxAttendees ||
                  !checkAvilabilityIsNotInThePast(
                    `${_unref(DateTimeToISOString)(day.value)}T${availability.time}`
                  ),
              }, "border shadow shadow-primary border-primary bg-primary text-center font-medium text-white p-4 hover:bg-white hover:text-primary hover:cursor-pointer"]),
                              key: availabilityIndex,
                              onClick: ($event: any) => (chooseAt(availability.time))
                            }, _toDisplayString(availability.time), 11, _hoisted_20))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("p", _hoisted_22, "(" + _toDisplayString(_ctx.$t("noAvailabilities")) + ")", 1)
                        ]))
                ]))
              : _createCommentVNode("", true),
            (step.value == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("form", {
                    class: "flex flex-col gap-4 p-4",
                    onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("gender")), 1),
                      _createVNode(_unref(PDropdown), {
                        class: "w-full",
                        placeholder: _ctx.$t('gender'),
                        options: _unref(genderList)(_ctx.$t),
                        "option-label": "name",
                        "option-value": "id",
                        "data-key": "id",
                        modelValue: _unref(v$).gender.$model,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).gender.$model) = $event))
                      }, null, 8, ["placeholder", "options", "modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(v$).gender.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("phoneNumber")), 1),
                      _createVNode(CPhoneInput, {
                        modelValue: booking.value.client.phoneNumber,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((booking.value.client.phoneNumber) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(v$).phoneNumber.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("firstName")), 1),
                      _createVNode(_unref(PInput), {
                        modelValue: _unref(v$).firstName.$model,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).firstName.$model) = $event)),
                        class: "w-full"
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(v$).firstName.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("lastName")), 1),
                      _createVNode(_unref(PInput), {
                        modelValue: _unref(v$).lastName.$model,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).lastName.$model) = $event)),
                        class: "w-full"
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(v$).lastName.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("email")), 1),
                      _createVNode(_unref(PInput), {
                        modelValue: _unref(v$).email.$model,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).email.$model) = $event)),
                        class: "w-full"
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(v$).email.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("comment")), 1),
                      _createVNode(_unref(PTextArea), {
                        modelValue: booking.value.comment,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((booking.value.comment) = $event)),
                        class: "w-full p-2 min-h-[4rem]"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex justify-end items-center gap-x-4", { 'pointer-events-none': isLoading.value }])
                    }, [
                      _createVNode(CButton, {
                        class: "!font-medium",
                        onClick: book
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("book")), 1)
                        ]),
                        _: 1
                      })
                    ], 2)
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_routerLink, {
          to: { name: 'TermsOfUse' },
          class: "underline",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("termsOfUse")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createTextVNode(_toDisplayString(_ctx.$t("proposedBy")) + " ", 1),
      _hoisted_32
    ])
  ]))
}
}

})